<template>
  <div id="buy-history">
    <div class="inner_static">
      <h2 class="tit_mypage2">購入履歴</h2>
      <ul class="lst_buy-history">
        <li v-for="(item,index) in dispList" :key="index">
          <a>
            <strong class="thumb">
              <img :src="getImage('e0_plan_img4.jpg')" @error="noImage" alt="キッチン収納 D01-5077141-7221841">
            </strong>
            <span class="ins_wrap">
              <strong class="name">{{item.productName}}</strong>
              <span class="code"><span class="item">注文番号：</span>{{formatOrderNo(item.orderNo)}}</span>
              <span class="date">注文日：{{dateFormat(item.orderDate)}}</span>
              <span class="price">合計：{{formatPrice(item.totalPrice)}}</span>
            </span>
          </a>
        </li>
      </ul>
      <div class="btn_area" v-if="this.purchaseList.length > this.upperLimit">
        <a class="btn_more2" @click="btnMoreClick()">More</a>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../../utils/App'

export default {
  data () {
    return {
    }
  },
  props: {
    purchaseList: {
      type: Array,
      default: function () { return [] }
    },
    upperLimit: {
      type: Number,
      default: -1
    }
  },
  methods: {
    btnMoreClick: function () {
      this.$emit('clickHistoryMoreEvent')
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    formatOrderNo: function (orderNo) {
      if (!orderNo) return ''
      return orderNo.substring(0, 3) + '-' + orderNo.substring(3, 7) + '-' + orderNo.substring(8)
    },
    dateFormat: function (dateStr) {
      let temp = new Date(Number(dateStr.substring(0, 4)), Number(dateStr.substring(4, 6)) - 1, Number(dateStr.substring(6, 8)))
      let format = 'YYYY年MM月dd日'.replace(/YYYY/g, temp.getFullYear())
      format = format.replace(/MM/g, (temp.getMonth() + 1))
      format = format.replace(/dd/g, (temp.getDate()))
      return format
    },
    getImage: function (image) {
      return App.getKagullResource(image)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    }
  },
  computed: {
    dispList: function () {
      if (this.upperLimit < 0) {
        return this.purchaseList
      } else {
        return this.purchaseList.slice(0, this.upperLimit)
      }
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/mypage/PurchaseHistory.vue